<template>
  <aside
    class="md:min-h-screen md:pl-4 md:pt-4 w-[300px]"
    :data-testid="`${dataTestId}-menu`"
  >
    <slot name="sidebarSections">
      <div
        v-for="(section, index) in sections"
        :key="index"
        :data-testid="`${dataTestId}-section-${index}`"
      >
        <sidebar-section
          :title="section.title"
          :items="section.items"
          :data-test-id="`${dataTestId}-section-${index}`"
          @menu-item-clicked="handleMenuItemClick"
        />
      </div>
    </slot>
  </aside>
</template>

<script setup>
import SidebarSection from "./SidebarSection.vue";

defineProps({
  title: {
    type: String,
    required: true,
  },
  sections: {
    type: Array,
    required: false,
    default: [],
  },
  dataTestId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["menu-item-clicked"]);

const handleMenuItemClick = () => {
  emit("menu-item-clicked");
};
</script>
